class SiteAlert extends HTMLElement {

  constructor() {
    super();
    this.alertMessage = this.querySelector('.js-alert-message');
    this.close = this.querySelector('.js-alert-close');
    this.listeners();
    this.timeout = null;
  }

  listeners() {
    document.addEventListener('alert:show', (e) => {
      this.showAlert(e);
    });

    document.addEventListener('alert:clear', () => {
      this.clearAlert();
    });

    if (this.close) {      
      this.close.addEventListener('click', () => {
        this.clearAlert();
      })
    }
  }

  showAlert(e) {
    if (this.timeout) {clearTimeout(this.timeout)}

    if (this.alertMessage) {
      this.classList.remove('site-alert--hidden');
      this.alertMessage.innerHTML = e.detail.data.message;
    }

    this.timeout = setTimeout(() => {
      if (this.alertMessage) {
        this.alertMessage.innerHTML = ''
      }
      this.classList.add('site-alert--hidden');
    }, 10000);
  }

  clearAlert() {
    if (this.timeout) {clearTimeout(this.timeout)}
    if (this.alertMessage) {
      this.alertMessage.innerHTML = ''
    }
    this.classList.add('site-alert--hidden');
  }
}

customElements.define('site-alert', SiteAlert);
